var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.employer_match_contribution_type}},[_c('v-select',{attrs:{"name":"employer_match_contribution_type","options":[
      {
        code: 1,
        label:
          'Compensation Based'
      },
      {
        code: 2,
        label:
          'Contribution Based'
      }
    ],"reduce":function (label) { return label.code; },"required":""},on:{"input":_vm.resetBased},model:{value:(_vm.design.$model.employer_match_contribution_type),callback:function ($$v) {_vm.$set(_vm.design.$model, "employer_match_contribution_type", _vm._n($$v))},expression:"design.$model.employer_match_contribution_type"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }